export const SET_MAP_EDITOR_SCENE = "SET_MAP_EDITOR_SCENE";
export const RESET_MAP_EDITOR = "RESET_MAP_EDITOR";

const initial = {scene: null};

export default function mapEditor(state = initial, action) {
    switch (action.type) {
        case SET_MAP_EDITOR_SCENE:
            return {...state, scene: action.scene};
        case RESET_MAP_EDITOR:
            return initial;
        default:
            return state;
    }
}
